// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3iX38","col":"styles_col__jEhhD"};